import apiRequest from '@/apiRequest'
import { AxiosResponse } from 'axios'
import ApiRequestPaths from '@/apiRequestPaths'

export interface DefaultProductLink {
  instanceId: string,
  catalogId: string,
  productId: string,
}

export interface DefaultProductsLinks {
  links: Array<DefaultProductLink>,
}

export interface DefaultProduct {
  id: string,
  title: string,
  link: string,
  imageLink: string,
}

export class DefaultProductApiRequest {
    static addDefaultProduct(defaultProductLink: DefaultProductLink): Promise<AxiosResponse<any>> {
      return apiRequest.post<any>(ApiRequestPaths.ADD_SOCIAL_STREAM_DEFAULT_PRODUCT, defaultProductLink)
    }

    static removeDefaultProduct(defaultProductLink: DefaultProductLink): Promise<AxiosResponse<any>> {
      return apiRequest.post<any>(ApiRequestPaths.REMOVE_SOCIAL_STREAM_DEFAULT_PRODUCT, defaultProductLink)
    }

    static getDefaultProducts(instanceId: string): Promise<AxiosResponse<any>> {
      return apiRequest.get<any>(ApiRequestPaths.GET_SOCIAL_STREAM_DEFAULT_PRODUCTS.replace('{instanceId}', instanceId))
    }
}
